// translations/common.ts
export const translations = {
    en: {
      'errors.insufficientCredits': 'Insufficient credits. Please purchase credits or subscribe.',
      'errors.xmlBlurredMessage': 'Download the complete XRechnung to see all data (uses 1 credit).',
      'errors.moneyBackGuarantee': '100% money back guarantee if XRechnung does not comply with requirements.',
      'errors.fetchUserStatusFailed': 'Failed to fetch user status',
      'errors.deductCreditFailed': 'Failed to deduct credit',
      'errors.downloadCheckFailed': 'Failed to check download',
      'errors.missingDownloadData': 'Missing download data',
  
      'seo.title': '{title} - Invoice-Converter.com',
      'seo.defaultDescription': 'Convert PDF invoices to XRechnung XML format easily with our AI-powered solution.',
      'seo.defaultTitle': 'PDF to XRechnung Converter',
  
      'common.welcome': 'Welcome, {{name}}!',
      'common.uploadInvoice': 'Upload Invoice',
      'common.to': 'to',
      'common.cancel': 'Cancel',
      'common.confirm': 'Confirm',
      'common.and': 'and',
  
      'feedback.button': 'Feedback?',
      'feedback.title': 'Help us improve!',
      'feedback.placeholder.message': 'What could be improved?',
      'feedback.placeholder.email': 'Your email (optional)',
      'feedback.submit': 'Send Feedback',
      'feedback.sending': 'Sending...',
      'feedback.success': 'Thank you for your feedback! 🎉',
  
      'footer.quickLinks': 'Quick Links',
      'footer.services': 'Features', // Grouped here as a general site link/element
    },
    de: {
      'errors.insufficientCredits': 'Nicht genügend Credits. Bitte Credits kaufen oder abonnieren.',
      'errors.xmlBlurredMessage': 'Laden Sie die vollständige XRechnung herunter, um alle Daten zu sehen (verwendet 1 Credit).',
      'errors.moneyBackGuarantee': '100% Geld-zurück-Garantie, falls die XRechnung nicht den Anforderungen entspricht.',
      'errors.fetchUserStatusFailed': 'Failed to fetch user status', // Needs translation
      'errors.deductCreditFailed': 'Failed to deduct credit', // Needs translation
      'errors.downloadCheckFailed': 'Failed to check download', // Needs translation
      'errors.missingDownloadData': 'Missing download data', // Needs translation
  
      // This nested errors object was only present in the original DE section
      'errors': {
        'pdfOnly': 'Es sind nur PDF-Dateien erlaubt',
        'fileTooLarge': 'Datei zu groß. Maximale Größe ist 10MB',
        'noTextExtracted': 'Text konnte nicht aus PDF extrahiert werden. Bitte stellen Sie sicher, dass die PDF Text enthält und nicht passwortgeschützt ist.',
        'processingFailed': 'Rechnungsdaten konnten nicht aus der PDF verarbeitet werden',
        'invalidResponse': 'Ungültige Antwort vom Server. Bitte versuchen Sie es erneut.',
        'authenticationRequired': 'Authentifizierung erforderlich. Bitte melden Sie sich an.',
        'upload': {
          'noFileSelected': 'Bitte wählen Sie eine Datei aus.',
        }
      },
  
      'seo.title': '{title} - Invoice-Converter.com',
      'seo.defaultDescription': 'Konvertieren Sie PDF-Rechnungen einfach in das XRechnung XML-Format mit unserer KI-gestützten Lösung.',
      'seo.defaultTitle': 'PDF zu XRechnung Konverter',
  
      'common.welcome': 'Willkommen, {{name}}!',
      'common.uploadInvoice': 'Rechnung hochladen',
      'common.and': 'und',
      'common.to': 'zu',
      'common.cancel': 'Abbrechen',
      'common.confirm': 'Confirm', // Needs translation
  
      'feedback.button': 'Feedback?',
      'feedback.title': 'Helfen Sie uns besser zu werden!',
      'feedback.placeholder.message': 'Was können wir verbessern?',
      'feedback.placeholder.email': 'Ihre E-Mail (optional)',
      'feedback.submit': 'Feedback senden',
      'feedback.sending': 'Wird gesendet...',
      'feedback.success': 'Vielen Dank für Ihr Feedback! 🎉',
  
      'footer.quickLinks': 'Schnellzugriff',
      'footer.services': 'Features', // Grouped here as a general site link/element
    }
  };